import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { CommonDialog } from "../common/CommonComponents/Dialog";
import { DeclineButton } from "../common/CommonComponents/Buttons";
import { HoverTableRow, TableFirstRow, StyledPaper, TableWrapper, PlatformDetailsWrapper, PlatformWrapper, PlatformTitleWrapper, StyledTabs } from "./FuiStyles";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  DialogActions,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Chip,
  Typography,
  Box,
  Card,
  CardContent,
  LinearProgress,
  CircularProgress,
  TextField,
  Paper,
  Tab,
  TablePagination,
  InputAdornment
  // , Grid
} from "@material-ui/core";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent
} from '@material-ui/lab';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { XSmallHeader } from "../common/CommonStyles/CommonTypographyStyles";
import {
  StyledAvatar,
  ProgressWrapper,
  SuccessWrapper,
  ButtonWrapperFromSsh,
  FinalWrapperFromSsh,
  ToAccessTypography,
} from "./FuiStyles";
import base from "../../config";
import { headers } from "../../helper/api";
import axios from "axios";
import RemoveIcon from "@material-ui/icons/Remove";
import TrackChangesIcon from "@material-ui/icons/TrackChanges";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import PersonIcon from "@material-ui/icons/Person";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import SearchIcon from "@material-ui/icons/Search";
import { PrimaryButton } from "../common/CommonComponents/Buttons";

/**
 * Components which shows order requests
 * @author shilpa.adikeshava
 * @version 1.0
 */

// Custom styles for journey tracker
const useJourneyStyles = makeStyles((theme) => ({
  journeyDialog: {
    '& .MuiDialog-paper': {
      maxWidth: '95vw',
      maxHeight: '90vh',
      minWidth: '900px',
      width: '1200px'
    }
  },
  journeyContent: {
    maxHeight: '70vh',
    overflow: 'auto',
    padding: theme.spacing(2)
  },
  progressBar: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  timelineContainer: {
    padding: theme.spacing(2, 0)
  },
  trackButton: {
    background: 'linear-gradient(135deg, #7500C0 0%, #5a0090 100%)',
    color: 'white',
    padding: '6px 12px',
    fontSize: '0.75rem',
    minWidth: 'auto',
    '&:hover': {
      background: 'linear-gradient(135deg, #5a0090 0%, #450070 100%)',
    },
  },
}));



const OrderRequestsList = ({ data, history, isLoading, onRefreshData }) => {
  const classes = useJourneyStyles();
  const [openDeclinedReasonPopup, setDeclinedReasonPopup] = useState(false);
  const [declinedReason, setDeclinedReason] = useState("");
  const [openJourneyDialog, setOpenJourneyDialog] = useState(false);
  const [selectedJourney, setSelectedJourney] = useState(null);
  const [journeyLoading, setJourneyLoading] = useState(false);
  const [journeyError, setJourneyError] = useState(null);

  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Search state
  const [searchQuery, setSearchQuery] = useState("");

  // Clarification popup state
  const [openClarificationPopup, setClarificationPopup] = useState(false);
  const [clarificationResponse, setClarificationResponse] = useState("");
  const [clarificationQuestion, setClarificationQuestion] = useState("");
  const [selectedOrderForClarification, setSelectedOrderForClarification] = useState(null);
  const [clarificationLoading, setClarificationLoading] = useState(false);
  const [clarificationSuccess, setClarificationSuccess] = useState(false);

  const handleOpen = (data) => {
    if (data.OrderItems[0].Config.find(item => item.Key === "DeclinedReason")) {
      const reason = data.OrderItems[0].Config.find(item => item.Key === "DeclinedReason")['Value']
      setDeclinedReason(reason)
    } else {
      setDeclinedReason("")
    }
    setDeclinedReasonPopup(true);
  };

  // Handle clarification popup
  const handleClarificationOpen = (data) => {
    setSelectedOrderForClarification(data);

    // Get the LATEST clarification question from history or fallback to legacy field
    const config = data.OrderItems[0].Config;
    let latestClarificationQuestion = "Please provide additional information for this request.";

    // First try to get latest from clarification history
    const historyEntries = [];
    config.forEach(item => {
      if (item.Key && item.Key.startsWith('ClarificationHistory_')) {
        try {
          const historyData = JSON.parse(item.Value);
          historyEntries.push(historyData);
        } catch (e) {
          // Ignore parsing errors
        }
      }
    });

    if (historyEntries.length > 0) {
      // Sort by round and timestamp to get latest REQUEST
      historyEntries.sort((a, b) => {
        if (b.round !== a.round) return b.round - a.round;
        return new Date(b.timestamp) - new Date(a.timestamp);
      });

      // Find the latest clarification REQUEST
      const latestRequest = historyEntries.find(e => e.type === 'REQUEST');
      if (latestRequest && latestRequest.comments) {
        latestClarificationQuestion = latestRequest.comments;
      }
    } else {
      // Fallback to legacy field if no history found
      const clarificationConfig = config.find(item => item.Key === "ClarificationComments");
      if (clarificationConfig && clarificationConfig.Value) {
        latestClarificationQuestion = clarificationConfig.Value;
      }
    }

    setClarificationQuestion(latestClarificationQuestion);

    // Always start with empty response field for new clarification
    setClarificationResponse("");

    setClarificationPopup(true);
  };

  // Submit clarification response
  const handleClarificationSubmit = async () => {
    if (!clarificationResponse.trim()) {
      alert("Please enter your clarification response");
      return;
    }

    setClarificationLoading(true);

    try {
      const orderItemUId = selectedOrderForClarification.OrderItems[0].OrderItemUId;


      const idToken = localStorage.getItem("token");
      const params = new URLSearchParams({
        request_id: orderItemUId,
        clarification_response: clarificationResponse
      });

      // Call API to update the order with clarification response
      const response = await axios.post(
        `${base.urls.apis.order}/approvals/update_clarification_response?${params.toString()}`,
        null,
        { headers: { ...headers, Authorization: idToken } }
      );

      setClarificationSuccess(true);
    } catch (error) {
      console.error('Error submitting clarification:', error);
      alert(`Network error: ${error.message || 'Please check your connection and try again.'}`);
    } finally {
      setClarificationLoading(false);
    }
  };

  const handleTrackClick = async (requestId) => {
    setJourneyLoading(true);
    setJourneyError(null);
    setOpenJourneyDialog(true);

    try {
      const idToken = localStorage.getItem("token");
      const response = await fetch(`${base.urls.apis.order}/approvals/journey?request_id=${requestId}`, {
        method: 'GET',
        headers: {
          ...headers,
          Authorization: idToken
        }
      });

      if (response.ok) {
        const journeyData = await response.json();
        setSelectedJourney(journeyData);
      } else {
        throw new Error(`Failed to fetch journey data: ${response.status}`);
      }
    } catch (error) {
      console.error('Error fetching journey data:', error);
      setJourneyError('Failed to load journey data. Please try again.');
    } finally {
      setJourneyLoading(false);
    }
  };

  const handleCloseJourney = () => {
    setOpenJourneyDialog(false);
    setSelectedJourney(null);
    setJourneyError(null);
    setJourneyLoading(false);
  };

  const formatStageName = (stageName) => {
    if (stageName === 'Level 1 Approval') {
      return 'Pending Approval';
    }
    return stageName;
  };

  const getTimelineDotColor = (status) => {
    switch (status.toLowerCase()) {
      case 'completed':
        return '#4caf50';
      case 'approved':
        return '#4caf50';
      case 'deployment_in_progress':
        return '#2196f3'; // Blue color for deployment in progress
      case 'pending':
        return '#ff9800';
      case 'waiting':
        return '#bdbdbd';
      case 'ready':
        return '#4caf50'; // Keep green for backward compatibility
      case 'cancelled':
        return '#f44336'; // Red for cancelled
      case 'failed':
        return '#f44336'; // Red for failed
      case 'rejected':
        return '#f44336';
      case 'clarification_requested':
        return '#ffc107';
      case 'clarification_response_provided':
        return '#2196f3';
      default:
        return '#bdbdbd';
    }
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const calculateProgress = (journey) => {
    if (!journey) return 0;
    const completedSteps = journey.filter(step =>
      step.status.toLowerCase() === 'completed' ||
      step.status.toLowerCase() === 'approved'
    ).length;
    return (completedSteps / journey.length) * 100;
  };

  const sortedRequestedData = data && Array.isArray(data) ? data.sort((a, b) => new Date(b.OrderItems[0].CreatedDate) - new Date(a.OrderItems[0].CreatedDate)) : [];

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  // Search handler
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to first page when searching
  };

  // Filter data based on search query
  const filteredData = sortedRequestedData.filter((row) => {
    if (!searchQuery.trim()) return true;

    const searchLower = searchQuery.toLowerCase();
    const requestId = row.OrderItems[0].OrderItemUId.toLowerCase();
    const clientName = (row.ClientName === "myWizard AiOps" ? "GenWizard AiOps" : row.ClientName).toLowerCase();

    const productConfig = row.OrderItems[0].Config.find(item => item.Key === "AaamPlatformType");
    const productName = productConfig && productConfig.Value ? productConfig.Value.toLowerCase() : '';

    const domainConfig = row.OrderItems[0].Config.find(item => item.Key === "DomainContextRoot");
    const domainContext = (domainConfig && domainConfig.Value ? domainConfig.Value : row.DMSId || '').toLowerCase();

    const approverConfig = row.OrderItems[0].Config.find(item => item.Key === "Approver");
    const approver = (approverConfig && approverConfig.Value ? approverConfig.Value : '').toLowerCase();

    const statusConfig = row.OrderItems[0].Config.find(item => item.Key === "ApprovalStatus");
    const status = (statusConfig && statusConfig.Value ? statusConfig.Value : '').toLowerCase();

    return requestId.includes(searchLower) ||
           clientName.includes(searchLower) ||
           productName.includes(searchLower) ||
           domainContext.includes(searchLower) ||
           approver.includes(searchLower) ||
           status.includes(searchLower);
  });

  // Get paginated data from filtered results
  const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      {/* Search Bar */}
      <Box style={{ padding: "16px", backgroundColor: "#f5f5f5" }}>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Search orders by ID, client name, product, domain, approver, or status..."
          value={searchQuery}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {isLoading ? (
            <div style={{ height: "90%", maxHeight: "90%" }}>
              <ProgressWrapper
                style={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </ProgressWrapper>
            </div>
          ) : (sortedRequestedData.length === 0) ? (
            <FinalWrapperFromSsh>
              <SuccessWrapper>
                <StyledAvatar>
                  <RemoveIcon />
                </StyledAvatar>
                <ToAccessTypography>
                  You haven't ordered any instance!
                </ToAccessTypography>
              </SuccessWrapper>
              <ButtonWrapperFromSsh>
                <PrimaryButton
                  onClick={() => history.push("/fui/order")}
                  data-cy="goToOrderAnInstance"
                  label={"GO TO ORDER AN INSTANCE"}
                  style={{ background: "#7500C0", color: "#FFF" }}
                // className={classes.FuiPrimaryButton}
                />
              </ButtonWrapperFromSsh>
            </FinalWrapperFromSsh>
          ) : (
            <StyledPaper style={{ marginTop: "1%", height: "400px", display: "flex", flexDirection: "column" }}>
              <div style={{ flex: 1, overflow: "auto" }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableFirstRow align="center">REQUEST ID</TableFirstRow>
                      <TableFirstRow align="center">CLIENT NAME</TableFirstRow>
                      <TableFirstRow align="center">PRODUCT NAME</TableFirstRow>
                      <TableFirstRow align="center">DOMAIN CONTEXT ROOT</TableFirstRow>
                      <TableFirstRow align="center">CREATED DATE</TableFirstRow>
                      <TableFirstRow align="center">APPROVER</TableFirstRow>
                      <TableFirstRow align="center">STATUS</TableFirstRow>
                      <TableFirstRow align="center">ACTIONS</TableFirstRow>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData.map((row, key) => (
                    <HoverTableRow key={key}>
                      <TableCell align="center">{row.OrderItems[0].OrderItemUId}</TableCell>
                      <TableCell align="center">{row.ClientName === "myWizard AiOps" ? "GenWizard AiOps" : row.ClientName}</TableCell>
                      <TableCell align="center">
                        {
                          row.OrderItems[0].Config.find(item => item.Key === "AaamPlatformType")['Value'].includes("myWizard AiOps") 
                          ? row.OrderItems[0].Config.find(item => item.Key === "AaamPlatformType")['Value'].replace('myWizard AiOps','') 
                          : row.OrderItems[0].Config.find(item => item.Key === "AaamPlatformType")['Value']
                        }
                      </TableCell>
                      <TableCell align="center">{row.OrderItems[0].Config.find(item => item.Key === "DomainContextRoot")['Value'] == "" ? row.DMSId : row.OrderItems[0].Config.find(item => item.Key === "DomainContextRoot")['Value']}</TableCell>
                      <TableCell align="center">{row.OrderItems[0].CreatedDate ? row.OrderItems[0].CreatedDate.split("T")[0] : row.OrderItems[0].CreateDate.split("T")[0]}</TableCell>
                      <TableCell align="center">{row.OrderItems[0].Config.find(item => item.Key === "Approver") ? row.OrderItems[0].Config.find(item => item.Key === "Approver")['Value'].split("@")[0] : "NA"}</TableCell>
                      <TableCell align="center">
                        {/* Clean Status Only */}
                        {row.OrderItems[0].Config.find(item => item.Key === "ApprovalStatus") ?
                          (() => {
                            const status = row.OrderItems[0].Config.find(item => item.Key === "ApprovalStatus")['Value'];

                            if (status === "Pending Approval")
                              return <Chip label="Pending Approval" size="small" style={{ backgroundColor: "#fff4e6", color: "#d68910", fontSize: "11px", fontWeight: "600", height: "26px", border: "1px solid #f39c12", minWidth: "120px" }} />
                            else if (status === "Pending L1 Approval")
                              return <Chip label="Pending Approval" size="small" style={{ backgroundColor: "#fff4e6", color: "#d68910", fontSize: "11px", fontWeight: "600", height: "26px", border: "1px solid #f39c12", minWidth: "140px" }} />
                            else if (status === "Pending L2 Approval")
                              return <Chip label="Pending Approval" size="small" style={{ backgroundColor: "#fff4e6", color: "#d68910", fontSize: "11px", fontWeight: "600", height: "26px", border: "1px solid #f39c12", minWidth: "140px" }} />
                            else if (status === "Clarification Requested")
                              return <Chip label="Clarification Requested" size="small" style={{ backgroundColor: "#fff3cd", color: "#856404", fontSize: "11px", fontWeight: "600", height: "26px", border: "1px solid #ffc107", minWidth: "150px" }} />
                            else if (status === "Approved")
                              return <Chip label="Approved" size="small" style={{ backgroundColor: "#d4edda", color: "#155724", fontSize: "11px", fontWeight: "600", height: "26px", border: "1px solid #28a745", minWidth: "80px" }} />
                            else if (status === "Declined")
                              return <Chip
                                label="Declined"
                                size="small"
                                onClick={() => handleOpen(row)}
                                clickable
                                style={{ backgroundColor: "#f8d7da", color: "#721c24", fontSize: "11px", fontWeight: "600", height: "26px", border: "1px solid #dc3545", cursor: "pointer", minWidth: "80px" }}
                              />
                            else
                              return <Chip label={status} size="small" style={{ backgroundColor: "#e9ecef", color: "#495057", fontSize: "11px", fontWeight: "600", height: "26px", minWidth: "100px" }} />
                          })() :
                          <Chip label="N/A" size="small" style={{ backgroundColor: "#e9ecef", color: "#6c757d", fontSize: "11px", height: "26px", minWidth: "60px" }} />
                        }
                      </TableCell>
                      <TableCell align="center">
                        {/* Dedicated Actions Column */}
                        <Box display="flex" alignItems="center" justifyContent="center">
                          <Button
                            className={classes.trackButton}
                            size="small"
                            startIcon={<TrackChangesIcon style={{ fontSize: 14 }} />}
                            onClick={() => handleTrackClick(row.OrderItems[0].OrderItemUId)}
                            disabled={isLoading}
                            style={{
                              fontSize: "10px",
                              padding: "4px 8px",
                              minWidth: "auto",
                              height: "28px"
                            }}
                          >
                            Track
                          </Button>

                          {/* Clarification Response Button */}
                          {row.OrderItems[0].Config.find(item => item.Key === "ApprovalStatus") &&
                           row.OrderItems[0].Config.find(item => item.Key === "ApprovalStatus")['Value'] === "Clarification Requested" && (
                            <Button
                              size="small"
                              variant="contained"
                              onClick={() => handleClarificationOpen(row)}
                              style={{
                                backgroundColor: "#fff3cd",
                                color: "#856404",
                                border: "1px solid #ffc107",
                                fontSize: "10px",
                                fontWeight: "500",
                                textTransform: "none",
                                minWidth: "auto",
                                padding: "4px 8px",
                                height: "28px",
                                marginLeft: "12px"
                              }}
                            >
                              Respond
                            </Button>
                          )}
                        </Box>
                      </TableCell>
                    </HoverTableRow>
                  ))}
                </TableBody>
                </Table>
              </div>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                style={{ borderTop: "1px solid #e0e0e0" }}
              />
            </StyledPaper>
          )}

      {/* Journey Tracker Dialog */}
      <Dialog open={openJourneyDialog} onClose={handleCloseJourney} className={classes.journeyDialog}>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" style={{ color: '#6a1b9a' }}>
               ORDER ID - {selectedJourney && selectedJourney.request_id}
            </Typography>
            <Chip
              label={`${Math.round(calculateProgress(selectedJourney && selectedJourney.journey))}% Complete`}
              style={{ backgroundColor: '#6a1b9a', color: 'white' }}
            />
          </Box>
          <LinearProgress
            variant="determinate"
            value={calculateProgress(selectedJourney && selectedJourney.journey)}
            className={classes.progressBar}
            style={{ backgroundColor: '#e0e0e0' }}
          />
        </DialogTitle>

        <DialogContent className={classes.journeyContent}>
          {journeyLoading && (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
              <Box textAlign="center">
                <CircularProgress size={48} style={{ color: '#6a1b9a', marginBottom: 16 }} />
                <Typography variant="h6" style={{ color: '#666', marginBottom: 8 }}>
                  Loading order status data...
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Please wait while we fetch the order status
                </Typography>
              </Box>
            </Box>
          )}

          {journeyError && (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
              <Box textAlign="center">
                <Typography variant="h6" style={{ color: '#d32f2f', marginBottom: 8 }}>
                  Error Loading Journey
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {journeyError}
                </Typography>
              </Box>
            </Box>
          )}

          {!journeyLoading && !journeyError && selectedJourney && selectedJourney.journey && (
            <div className={classes.timelineContainer}>
              <Timeline>
                {selectedJourney.journey.map((step, index) => {
                  const isLast = index === selectedJourney.journey.length - 1;

                  // Debug log for clarification steps
                  if (step.status && (step.status.toLowerCase().includes('clarification') || step.stage.toLowerCase().includes('clarification'))) {
                  }

                  return (
                    <TimelineItem key={index}>
                      <TimelineOppositeContent style={{ maxWidth: '200px', minWidth: '180px', paddingRight: '20px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <Typography variant="caption" color="textSecondary">
                          {formatTimestamp(step.timestamp)}
                        </Typography>
                        <Chip
                          label={step.status}
                          size="small"
                          style={{
                            backgroundColor: getTimelineDotColor(step.status),
                            color: 'white',
                            fontSize: '0.65rem',
                            height: '22px',
                            marginTop: '4px',
                            minWidth: 'fit-content',
                            maxWidth: '180px',
                            textAlign: 'center'
                          }}
                        />
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineDot
                          style={{
                            backgroundColor: getTimelineDotColor(step.status),
                            border: '2px solid white',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                          }}
                        />
                        {!isLast && <TimelineConnector style={{ backgroundColor: '#e0e0e0' }} />}
                      </TimelineSeparator>
                      <TimelineContent style={{ paddingLeft: '24px' }}>
                        <Typography variant="body1" style={{ fontWeight: 600, marginBottom: '4px' }}>
                          {formatStageName(step.stage)}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" style={{ marginBottom: '8px' }}>
                          <PersonIcon style={{ fontSize: 16, marginRight: 4, verticalAlign: 'middle' }} />
                          {step.user || (step.status.toLowerCase() === 'waiting' || step.status.toLowerCase() === 'pending' ? 'Awaiting previous approval' : 'Not assigned')}
                        </Typography>

                        {/* Special visual indicator for deployment in progress */}
                        {step.status.toLowerCase() === 'deployment_in_progress' && (
                          <div style={{
                            backgroundColor: '#e3f2fd',
                            border: '1px solid #2196f3',
                            borderRadius: '8px',
                            padding: '12px',
                            marginTop: '8px',
                            fontSize: '13px'
                          }}>
                            <span style={{ color: '#1976d2', fontWeight: '500' }}>
                              Deployment is in progress. You will receive a mail shortly with further updates.
                            </span>
                          </div>
                        )}

                        {/* Show clarification details if this is a clarification step */}
                        {(step.status.toLowerCase() === 'clarification_requested' || step.stage.toLowerCase().includes('clarification')) && step.clarification_comments && (
                          <div style={{
                            backgroundColor: '#fff3cd',
                            border: '1px solid #ffc107',
                            borderRadius: '4px',
                            padding: '8px',
                            marginTop: '8px',
                            fontSize: '12px'
                          }}>
                            <Typography variant="caption" style={{ fontWeight: 'bold', color: '#856404' }}>
                              Clarification Requested:
                            </Typography>
                            <Typography variant="body2" style={{ fontSize: '12px', color: '#856404', marginTop: '4px' }}>
                              "{step.clarification_comments}"
                            </Typography>
                          </div>
                        )}

                        {/* Show clarification response if this is a response step */}
                        {step.status.toLowerCase() === 'clarification_response_provided' && step.clarification_response && (
                          <div style={{
                            backgroundColor: '#e3f2fd',
                            border: '1px solid #2196f3',
                            borderRadius: '4px',
                            padding: '8px',
                            marginTop: '8px',
                            fontSize: '12px'
                          }}>
                            <Typography variant="caption" style={{ fontWeight: 'bold', color: '#1976d2' }}>
                              Response Provided:
                            </Typography>
                            <Typography variant="body2" style={{ fontSize: '12px', color: '#1976d2', marginTop: '4px' }}>
                              "{step.clarification_response}"
                            </Typography>
                          </div>
                        )}

                        {/* Show comments if available for other steps - filter out clarification response comments */}
                        {step.comments && !step.clarification_comments && !step.clarification_response &&
                         !step.comments.startsWith('Clarification Response:') &&
                         step.comments.trim() !== '' && (
                          <Typography variant="body2" style={{
                            fontSize: '12px',
                            color: '#666',
                            marginTop: '4px',
                            fontStyle: 'italic'
                          }}>
                            Note: {step.comments}
                          </Typography>
                        )}
                      </TimelineContent>
                    </TimelineItem>
                  );
                })}
              </Timeline>
            </div>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseJourney} color="primary" variant="contained" style={{ backgroundColor: '#6a1b9a' }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {openDeclinedReasonPopup && (
        <CommonDialog
          open={openDeclinedReasonPopup}
          onClose={() => setDeclinedReasonPopup(false)}
          title={"Declined Reason"}
          dialogType={"fui"}
          textContent={
            <div>
              <p style={{ fontWeight: "400" }}>
                We regret to inform you that your order request has been declined!
              </p>
              {declinedReason !== "" ?
                <p>Reason: {declinedReason}</p> : ""}
            </div>
          }
          dialogActions={
            <DialogActions >
              <DeclineButton
                onClick={() => setDeclinedReasonPopup(false)}
                label={"CLOSE"}
                disabled={false}
              />
            </DialogActions>
          }
        ></CommonDialog>
      )}

      {/* Clarification Response Popup - Professional Design */}
      <Dialog
        open={openClarificationPopup}
        onClose={() => setClarificationPopup(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
          }
        }}
      >
        <DialogTitle style={{
          backgroundColor: '#6f2dbd',
          color: 'white',
          padding: '20px 24px',
          margin: 0
        }}>
          <Typography variant="h6" style={{ fontWeight: '600', fontSize: '18px' }}>
            Clarification Response Required
          </Typography>
          <Typography variant="body2" style={{ opacity: 0.9, marginTop: '4px', fontSize: '14px' }}>
            Request ID: {selectedOrderForClarification && selectedOrderForClarification.OrderItems && selectedOrderForClarification.OrderItems[0] ? selectedOrderForClarification.OrderItems[0].OrderItemUId : 'N/A'}
          </Typography>
        </DialogTitle>

        <DialogContent style={{ padding: '24px', maxHeight: '70vh', overflowY: 'auto' }}>

          {/* Success Message */}
          {clarificationSuccess ? (
            <Box textAlign="center" py={4}>
              <Box style={{
                borderRadius: '8px',
                padding: '24px',
                marginBottom: '20px'
              }}>
                <CheckCircleIcon style={{ color: '#28a745', fontSize: '48px', marginBottom: '16px' }} />
                <Typography variant="h6" style={{ marginBottom: '16px', fontSize: '18px', fontWeight: '600' }}>
                  Success!
                </Typography>
                <Typography variant="body1" style={{ lineHeight: '1.6', fontSize: '14px' }}>
                  Thank you! Your clarification has been submitted successfully. The approver has been notified and will review your response shortly. You can track the progress in your Order Request Status.
                </Typography>
              </Box>
            </Box>
          ) : (
            <>
              {/* Clarification Request Section */}
              <Box mb={3}>
                <Typography variant="h6" style={{ color: '#6f2dbd', marginBottom: '12px', fontSize: '16px', fontWeight: '600' }}>
                  Clarification Required
                </Typography>
                <Box style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #dee2e6',
                  borderRadius: '8px',
                  padding: '16px'
                }}>
                  <Typography variant="body1" style={{ color: '#495057', lineHeight: '1.6', fontSize: '14px' }}>
                    {clarificationQuestion}
                  </Typography>
                </Box>
              </Box>

          {/* Clarification History Section - if exists */}
          {(() => {
            const config = selectedOrderForClarification && selectedOrderForClarification.OrderItems && selectedOrderForClarification.OrderItems[0] ? selectedOrderForClarification.OrderItems[0].Config || [] : [];

            // Get clarification history entries
            const historyEntries = config.filter(item =>
              item.Key && item.Key.startsWith('ClarificationHistory_')
            ).map(item => {
              try {
                return JSON.parse(item.Value);
              } catch (e) {
                return null;
              }
            }).filter(Boolean);

            // Sort by round and timestamp
            historyEntries.sort((a, b) => {
              if (a.round !== b.round) return a.round - b.round;
              return new Date(a.timestamp) - new Date(b.timestamp);
            });

            // If no history, fall back to legacy single response check
            if (historyEntries.length === 0) {
              const prevResponseConfig = config.find(item => item.Key === "ClarificationResponse");
              const prevResponse = prevResponseConfig ? prevResponseConfig.Value : null;

              if (!prevResponse) return null;

              return (
                <Box mb={3}>
                  <Typography variant="h6" style={{ color: '#17a2b8', marginBottom: '12px', fontSize: '16px', fontWeight: '600' }}>
                    Your Previous Response
                  </Typography>
                  <Box style={{
                    backgroundColor: '#e7f3ff',
                    border: '1px solid #b3d7ff',
                    borderRadius: '8px',
                    padding: '16px'
                  }}>
                    <Typography variant="body2" style={{ color: '#004085', lineHeight: '1.6', fontSize: '14px', fontStyle: 'italic' }}>
                      {prevResponse}
                    </Typography>
                  </Box>
                </Box>
              );
            }

            // Group by rounds
            const rounds = {};
            historyEntries.forEach(entry => {
              if (!rounds[entry.round]) rounds[entry.round] = [];
              rounds[entry.round].push(entry);
            });

            return (
              <Box mb={3}>
                <Typography variant="h6" style={{ color: '#17a2b8', marginBottom: '12px', fontSize: '16px', fontWeight: '600' }}>
                  Clarification History
                </Typography>
                {Object.keys(rounds).map(roundNum => (
                  <Box key={roundNum} mb={1}>
                    {rounds[roundNum].map((entry, idx) => (
                      <Box key={idx} mb={1} style={{
                        backgroundColor: entry.type === 'REQUEST' ? '#fff3cd' : '#e7f3ff',
                        border: `1px solid ${entry.type === 'REQUEST' ? '#ffc107' : '#b3d7ff'}`,
                        borderRadius: '8px',
                        padding: '12px'
                      }}>
                        <Typography variant="caption" style={{
                          color: entry.type === 'REQUEST' ? '#856404' : '#004085',
                          fontSize: '12px',
                          fontWeight: '600'
                        }}>
                          {entry.type === 'REQUEST' ? 'Question from Approver' : 'Your Response'} • {new Date(entry.timestamp).toLocaleString()}
                        </Typography>
                        <Typography variant="body2" style={{
                          color: entry.type === 'REQUEST' ? '#856404' : '#004085',
                          lineHeight: '1.6',
                          fontSize: '14px',
                          marginTop: '4px'
                        }}>
                          {entry.type === 'REQUEST' ? entry.comments : entry.response}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            );
          })()}

          {/* Response Input Section */}
          <Box>
            <Typography variant="h6" style={{ color: '#28a745', marginBottom: '12px', fontSize: '16px', fontWeight: '600' }}>
              Your Response
            </Typography>
            <TextField
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              value={clarificationResponse}
              onChange={(e) => setClarificationResponse(e.target.value)}
              placeholder="Please provide the requested clarification..."
              InputProps={{
                style: {
                  fontSize: '14px',
                  lineHeight: '1.6'
                }
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: '#28a745',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#28a745',
                  },
                },
              }}
            />
            <Typography variant="caption" style={{
              color: '#6c757d',
              display: 'block',
              marginTop: '8px',
              fontSize: '12px'
            }}>
              Provide clear and detailed information to help expedite the approval process
            </Typography>
          </Box>
            </>
          )}

        </DialogContent>

        <DialogActions style={{
          padding: '16px 24px',
          backgroundColor: 'white',
          borderTop: '1px solid #e9ecef'
        }}>
          {clarificationSuccess ? (
            <Button
              onClick={() => {
                setClarificationPopup(false);
                setClarificationSuccess(false);
                setClarificationResponse("");
                // Call refresh function instead of page reload
                if (onRefreshData) {
                  onRefreshData();
                }
              }}
              variant="contained"
              style={{
                backgroundColor: '#6f2dbd',
                color: 'white',
                textTransform: 'none',
                fontWeight: '600',
                marginLeft: 'auto'
              }}
            >
              Close
            </Button>
          ) : (
            <>
              <Button
                onClick={() => setClarificationPopup(false)}
                variant="outlined"
                disabled={clarificationLoading}
                style={{
                  color: '#6c757d',
                  borderColor: '#dee2e6',
                  textTransform: 'none',
                  fontWeight: '500'
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleClarificationSubmit}
                variant="contained"
                disabled={!clarificationResponse.trim() || clarificationLoading}
                style={{
                  backgroundColor: clarificationLoading ? '#6c757d' : '#6f2dbd',
                  color: 'white',
                  textTransform: 'none',
                  fontWeight: '600',
                  marginLeft: '12px',
                  minWidth: '120px'
                }}
                startIcon={clarificationLoading ? <CircularProgress size={16} color="inherit" /> : null}
              >
                {clarificationLoading ? 'Submitting...' : 'Submit Response'}
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

const MSTP = (state) => ({
  isLoading: state.fui.isLoading,
});

OrderRequestsList.propTypes = {
  /**
   * History property of route library
   */
  history: PropTypes.object,
  /**
   * Data array for order requests
   */
  data: PropTypes.array,
  /**
   * Loading state
   */
  isLoading: PropTypes.bool,
  /**
   * Callback function to refresh data
   */
  onRefreshData: PropTypes.func,
};

export default connect(MSTP)(withRouter(OrderRequestsList));
